import { orderSpaceType } from "components/constants/DropdownOptions";
import React from "react";
import { Col, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useTranslation } from "react-i18next";
import Chair from "assets/images/icons/chair.svg";
import Riyal from "assets/images/icons/riyal.svg";
import Building from "assets/images/icons/building.svg";
import User from "assets/images/icons/userBlack.svg";
import Leaf from "assets/images/icons/leafBlack.svg";
import { useSelector } from "react-redux";

const OverviewRevenueCard = ({ item }) => {
  const { t } = useTranslation();
  const { loading, overviewDashboard } = useSelector(
    (state) => state.Dashboards
  );

  const workspace =
    overviewDashboard?.spaceTypeStats?.find(
      (item) => item.spaceTypeInt === 1
    ) || {};
  const meetingRoom =
    overviewDashboard?.spaceTypeStats?.find(
      (item) => item.spaceTypeInt === 2
    ) || {};
  const workshop =
    overviewDashboard?.spaceTypeStats?.find(
      (item) => item.spaceTypeInt === 3
    ) || {};
  const office = overviewDashboard?.spaceStats?.office || {};
  const hotDesk = overviewDashboard?.spaceStats?.hotDesk || {};
  const plan = overviewDashboard?.spaceStats?.plan || {};

  return (
    <>
      {/* First Row: Workspace, Meeting Room, Office */}
      <SpaceTypeCard title="Workspace" data={workspace} />
      <SpaceTypeCard title="Meeting Room" data={meetingRoom} />
      <SpaceTypeCard title="Office" data={office} />

      {/* Second Row: Hot Desk, Plan, Workshop */}
      <SpaceTypeCard title="Hot Desk" data={hotDesk} marginTop={15} />
      <PlanCard data={plan} />
      <WorkshopCard data={workshop} />
    </>
  );
};

export default OverviewRevenueCard;

const SpaceTypeCard = ({ title, data, marginTop = 0 }) => {
  const { t } = useTranslation();

  return (
    <Col md={4} style={{ padding: "0 6.5px", marginTop }}>
      <div className="inner_section">
        <div className="g_between">
          <h2 className="fs_20 text_black">{t(title)}</h2>
          <div className="total_bookings">
            <img src={Chair} alt="char" width={15} height={15} />
            <p className="fs_12 text_dark_gray">
              {t("Total Bookings")}:{" "}
              <span className="fs_14 text_black">
                {data?.totalBookings ?? "0"}
              </span>
            </p>
          </div>
        </div>
        <h3 className="fs_12 text_dark_gray">{t("Total Revenue")}</h3>
        <h2 className="fs_40 text_black">
          <img
            src={Riyal}
            width={25}
            height={27}
            alt="riyal"
            className="me-1"
          />
          {data?.totalRevenue?.toLocaleString("en-US") ?? "0"}
        </h2>
        <div className="occupancy_inner">
          <div className="d-flex gap-2">
            <img src={Building} alt="icon" width={15} height={15} />
            <p className="fs_12 text_dark_gray">{t("Occupancy Rate:")}</p>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <p className="fs_14 text_black">{data?.occupancyRate ?? 0}%</p>
              <div className="custom_progressbar">
                <ProgressBar now={data?.occupancyRate} />
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <p className="fs_12 text_dark_gray">
              {t("Expected Revenue at 100% Occupancy:")}
            </p>
            <div className="d-flex align-items-center">
              <img
                src={Riyal}
                width={10}
                height={11}
                alt="icon"
                className="mx-1"
              />
              <h2 className="fs_14 text_black">
                {(
                  data?.fullOccupancyRevenue || data?.totalExpectedRevenue
                )?.toLocaleString("en-US") ?? "0"}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

const PlanCard = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Col md={4} style={{ padding: "0 6.5px", marginTop: 15 }}>
      <div className="inner_section">
        <div className="g_between">
          <h2 className="fs_20 text_black">{t("Plan")}</h2>
          <div className="total_bookings">
            <img src={Chair} alt="char" width={15} height={15} />
            <p className="fs_12 text_dark_gray">
              {t("Total Bookings")}:{" "}
              <span className="fs_14 text_black">
                {data?.totalBookings ?? "0"}
              </span>
            </p>
          </div>
        </div>
        <h3 className="fs_12 text_dark_gray">{t("Total Revenue")}</h3>
        <h2 className="fs_40 text_black">
          <img
            src={Riyal}
            width={25}
            height={27}
            alt="riyal"
            className="me-1"
          />
          {data?.totalRevenue?.toLocaleString("en-US") ?? "0"}
        </h2>
        <div className="row dashboard_plan_card mt_10">
          {data?.breakdown?.map((option) => (
            <div className="col-lg-6 px-1" key={option._id}>
              <div className="single_card">
                <h2 className="fs_14 text_black">
                  {t(
                    orderSpaceType?.find((type) => type.value === option?._id)
                      ?.name
                  ) || ""}
                  :
                </h2>
                <div className="d-flex align-items-center gap-2">
                  <h2 className="fs_12 text_dark_gray">
                    {t("Total Bookings")}:
                  </h2>
                  <h2 className="fs_14 text_black">
                    {option?.totalBookings?.toLocaleString("en-US")}
                  </h2>
                </div>
                <div className="d-flex align-items-center gap-2 ">
                  <h2 className="fs_12 text_dark_gray">
                    {t("Total Revenue")}:
                  </h2>
                  <div className="d-flex align-items-center gap-1">
                    <img src={Riyal} width={10} height={11} alt="" />
                    <h2 className="fs_14 text_black">
                      {option?.totalRevenue?.toLocaleString("en-US")}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};

const WorkshopCard = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Col md={4} style={{ padding: "0 6.5px", marginTop: 15 }}>
      <div className="inner_section">
        <div className="g_between">
          <h2 className="fs_20 text_black">{t("Workshop")}</h2>
          <div className="total_bookings">
            <img src={Chair} alt="char" width={15} height={15} />
            <p className="fs_12 text_dark_gray">
              {t("Total Bookings")}:{" "}
              <span className="fs_14 text_black">
                {data?.totalBookings ?? "0"}
              </span>
            </p>
          </div>
        </div>
        <h3 className="fs_12 text_dark_gray">{t("Total Revenue")}</h3>
        <h2 className="fs_40 text_black">
          <img
            src={Riyal}
            width={25}
            height={27}
            alt="riyal"
            className="me-1"
          />
          {data?.totalRevenue?.toLocaleString("en-US") ?? "0"}
        </h2>
        <div className="occupancy_inner">
          <div className="d-flex gap-2">
            <img src={Building} alt="icon" width={15} height={15} />
            <p className="fs_12 text_dark_gray">{t("Occupancy Rate:")}</p>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <p className="fs_14 text_black">{data?.occupancyRate ?? 0}%</p>
              <div className="custom_progressbar">
                <ProgressBar now={data?.occupancyRate} />
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <p className="fs_12 text_dark_gray">
              {t("Expected Revenue at 100% Occupancy:")}
            </p>
            <div className="d-flex align-items-center">
              <img
                src={Riyal}
                width={10}
                height={11}
                alt="icon"
                className="mx-1"
              />
              <h2 className="fs_14 text_black">
                {data?.fullOccupancyRevenue?.toLocaleString("en-US") ?? "0"}
              </h2>
            </div>
          </div>
        </div>

        {/* Commission section for Workshop */}
        <div className="d-flex commission_inner">
          <div className="single_commission ">
            <img src={User} alt="user" width={15} height={15} />
            <div>
              <h2 className="fs_12 text_dark_gray">
                {t("Trainer commission")}
              </h2>
              <div className="d-flex align-items-center gap-1">
                <img src={Riyal} width={10} height={11} alt="" />
                <h2 className="fs_14 text_black">
                  {data?.trainerShare?.toLocaleString("en-US") ?? "0"}
                </h2>
              </div>
            </div>
          </div>
          <div className="single_commission ">
            <img src={Leaf} alt="user" width={10} height={9} className="mt-1" />
            <div>
              <h2 className="fs_12 text_dark_gray">{t("Ashjar commission")}</h2>
              <div className="d-flex align-items-center gap-1">
                <img src={Riyal} width={10} height={11} alt="" />
                <h2 className="fs_14 text_black">
                  {data?.companyShare?.toLocaleString("en-US") ?? "0"}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};
